import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { evaluationItemType, referenceType } from 'constants/types';
import { WysiwygEditor } from 'components/Shared/sharedComponents';
import { Divider } from 'components/Shared/sharedStyle';
import StatusButtons from 'components/CandidateView/StatusButtons';
import { getCompaniesSectionNum } from 'utils/candidateFormSections';
import { textBoxesRefsNames } from 'components/CandidateView/configCandidateView';

const Companies = ({ textBoxesRefs, defaultEvaluation, evaluation, updateEvaluationStatus }) => {
  const { t } = useTranslation();
  const sectionNumber = getCompaniesSectionNum() + 1;
  const sectionTitle = t('candidateViewSection.companies');

  return (
    <>
      <h2>{`${sectionNumber}. ${sectionTitle}`}</h2>
      <WysiwygEditor
        defaultValue={defaultEvaluation?.comment}
        editorRef={textBoxesRefs}
        saveRefInAnotherRef
        name={textBoxesRefsNames?.companiesComment}
        sectionTitle={sectionTitle}
      />
      <StatusButtons value={evaluation} evaluationKey="companies" onClick={updateEvaluationStatus} />
      <Divider />
    </>
  );
};

Companies.propTypes = {
  textBoxesRefs: referenceType.isRequired,
  defaultEvaluation: evaluationItemType.isRequired,
  evaluation: PropTypes.number,
  updateEvaluationStatus: PropTypes.func.isRequired,
};

export default Companies;
